import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AdminIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M12 3.111L4.727 6.343v4.849c0 4.485 3.103 8.679 7.273 9.697 4.17-1.018 7.273-5.212 7.273-9.697V6.343zm0 8.88h5.657c-.429 3.33-2.65 6.296-5.657 7.225V12H6.343V7.394L12 4.88z" />
  </SvgIcon>
);
AdminIcon.displayName = 'AdminIcon';
AdminIcon.muiName = 'SvgIcon';

export default AdminIcon;
